import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56c3707e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mx-auto flex justify-center" }
const _hoisted_2 = { class: "border-b-2 border-fuchsia-600 w-4/5 text-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-3xl mx-3 mt-10 mb-5" }, "登録されているユニット/CP一覧", -1))
const _hoisted_4 = { class: "flex flex-wrap w-4/5 mx-auto" }
const _hoisted_5 = { class: "card mx-2 p-3 hover:bg-gray-200" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "card_text text-md lg:text-lg mx-3 m-1 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RulePopup = _resolveComponent("RulePopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_RulePopup),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.units, (unit) => {
          return (_openBlock(), _createElementBlock("div", {
            key: unit.id,
            class: "mb-2 sm:w-1/2 lg:w-1/4 xl:w-1/5 w-full"
          }, [
            _createElementVNode("article", _hoisted_5, [
              _createElementVNode("a", {
                href: unit.url
              }, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(unit.original_name), 1)
              ], 8, _hoisted_6)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}